(() => {
  const root=document.querySelector('[data-shop-chat]');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  const $=s=>root.querySelector(s),zh=root.dataset.language==='zh';
  const copy=zh?{
    starters:{reading:'我想找适合我的解读。请先帮我区分免费练习和真人个人报告，再问我一个问题来选择。'},
    guide:'陪我看看当前这一页，告诉我可以从哪里开始。',
    working:'Mira 正在思考…',slow:'还在等待回复，首次唤醒可能稍慢一些。',
    failed:'这次没能收到回复，你写的内容还在。可以重试，或在“关于这位向导”中联系团队。',
    limited:'这会儿咨询有些多。稍后重试，或邮件联系团队。',
    empty:'请先输入消息（最多 2,000 字）。',human:'具体订单需要团队查看，你可以给他们写邮件。',email:'邮件联系团队',
    cleared:'我们重新开始。',storage:'这个浏览器暂时无法保留续聊内容，离开当前页后对话会清空。',
    draft:'你还有未发送的文字，可以先发送或编辑它。',me:'你',ai:'Mira · AI 向导',unknown:'当前页面',private:'这一页包含个人内容，我不会读取它。你可以自己描述想了解的部分。'
  }:{
    starters:{reading:'Help me find my reading. First explain free practice versus a personal report by a human, then ask one question to help me choose.'},
    guide:'Walk me through this page and help me find a place to begin.',
    working:'Mira is thinking…',slow:'Still waiting for a reply. Waking up can take a little longer.',
    failed:'The reply did not arrive. Your words are still here. Retry, or email the team under About this guide.',
    limited:'It is a little busy right now. Try again shortly, or email the team.',
    empty:'Please enter a message (up to 2,000 characters).',human:'For a specific order, you can email the team for help.',email:'Email the team',
    cleared:'A fresh place to begin.',storage:'This browser cannot keep a conversation between pages. This chat will clear when you leave.',
    draft:'You have an unsent thought. Send or edit it first.',me:'You',ai:'Mira · AI guide',unknown:'Current page',private:'This page contains personal content, which I do not read. You can describe what you would like help with.'
  };
  const panel=$('#FoolShopChat'),toggle=$('[data-chat-toggle]'),input=$('[data-chat-message]'),send=$('[data-chat-send]'),
    status=$('[data-chat-status]'),log=$('[data-chat-log]'),suggestions=$('[data-chat-suggestions]'),menu=$('[data-chat-menu]'),
    scroll=$('[data-chat-scroll]'),bottom=$('[data-chat-bottom]'),retry=$('[data-chat-retry]');
  const key='fool-mira-journey-v2:'+String(window.Shopify?.theme?.id||'store');
  const rootPath=(root.dataset.root||'/').replace(/\/+$/,'');
  const localePrefix=/^\/[a-z]{2}(?:-[a-zA-Z]{2})?$/.test(rootPath)?rootPath:'';
  const media=window.matchMedia('(max-width:700px)'),ttl=7200000;
  let history=[],latestChips=[],busy=false,generation=0,controller,lastFocus,persistence=true,hasOpened=false,lastAttempt;
  let locked=false,lockState,background=[],following=true;
  const text=(s,max)=>typeof s==='string'&&s.trim().length>0&&s.length<=max;
  function safeLink(value){
    if(!value||!text(value.label,180)||typeof value.url!=='string')return false;
    try{const u=new URL(value.url);return u.origin==='https://worldofthefool.com'&&!u.username&&!u.password&&!u.search&&
      (!u.hash||(u.pathname==='/products/three-card-tarot-reading'&&u.hash==='#free-practice'))&&
      /^(\/|\/products\/[a-z0-9-]+|\/pages\/[a-z0-9-]+|\/policies\/[a-z0-9-]+|\/collections\/(all|shop)|\/account)$/.test(u.pathname);}catch{return false;}
  }
  function valid(data){
    return data&&text(data.reply_message,1800)&&typeof data.needs_human==='boolean'&&Array.isArray(data.links)&&data.links.length<=3&&data.links.every(safeLink)&&
      Array.isArray(data.quick_follow_up_chips)&&data.quick_follow_up_chips.length<=3&&data.quick_follow_up_chips.every(s=>text(s,100));
  }
  function storageFailure(){persistence=false;const note=$('[data-chat-storage-note]');note.textContent=copy.storage;note.hidden=false;}
  function save(){
    if(!persistence)return;
    try{sessionStorage.setItem(key,JSON.stringify({v:2,at:Date.now(),history,draft:input.value.slice(0,2000),chips:latestChips}));}
    catch{storageFailure();}
  }
  function resize(){input.style.height='auto';input.style.height=Math.min(124,Math.max(44,input.scrollHeight))+'px';if(following)toBottom();}
  function sync(){
    send.disabled=busy||!input.value.trim();
    input.setAttribute('aria-busy',String(busy));retry.disabled=busy;
    for(const b of root.querySelectorAll('[data-chat-starter],[data-chat-explore],[data-chat-suggestions] button'))b.disabled=busy;
    $('[data-chat-welcome]').hidden=history.length>0;
    toggle.hidden=!panel.hidden;
  }
  function toBottom(){scroll.scrollTop=scroll.scrollHeight;following=true;bottom.hidden=true;}
  function nearBottom(){return scroll.scrollHeight-scroll.clientHeight-scroll.scrollTop<72;}
  function changed(){if(following)toBottom();else bottom.hidden=false;}
  function chips(values){
    latestChips=values;suggestions.replaceChildren();
    for(const value of values){const b=document.createElement('button');b.type='button';b.textContent=value;b.addEventListener('click',()=>start(value));suggestions.append(b);}
    sync();
  }
  const focusable=()=>Array.from(panel.querySelectorAll('button:not(:disabled),a[href],summary,textarea:not(:disabled)')).filter(el=>!el.closest('[hidden]')&&
    (!media.matches||!el.matches('[data-chat-minimize]'))&&
    (!el.closest('details')||el.closest('details').open||el===el.closest('details').querySelector('summary'))&&getComputedStyle(el).display!=='none');
  function priorityDialog(){
    const selectors='dialog[open],[aria-modal="true"],[data-header-search][open],#shopify-pc__banner,#shopify-pc__prefs,#shopify-pc__prefs__dialog,[data-cookie-banner],[data-consent-banner]'+
      (window.matchMedia('(min-width:1360px)').matches?'':',.site-header__drawer[open]');
    return Array.from(document.querySelectorAll(selectors))
      .find(el=>!root.contains(el)&&!el.closest('[hidden]')&&getComputedStyle(el).display!=='none'&&getComputedStyle(el).visibility!=='hidden');
  }
  let overlayFrame=0;
  function scheduleOverlay(){
    if(overlayFrame)return;
    overlayFrame=requestAnimationFrame(()=>{
      overlayFrame=0;
      const priority=priorityDialog();
      if(priority&&!panel.hidden)close(false);
      const editing=media.matches&&!root.contains(document.activeElement)&&document.activeElement?.matches('input:not([type="hidden"]),textarea,select,[contenteditable="true"]');
      let collision=false;
      if(panel.hidden){
        const r=toggle.getBoundingClientRect();
        if(r.width&&r.height)collision=Array.from(document.querySelectorAll('button[name="add"],[data-add-to-cart],.physical-product__tray,.reading-sticky,.mobile-conversion-bar,[data-pfm-confirm-actions]')).some(el=>{
          if(el.closest('[hidden]')||getComputedStyle(el).display==='none'||getComputedStyle(el).visibility==='hidden')return false;
          const b=el.getBoundingClientRect();return b.width>0&&b.height>0&&r.left<b.right+8&&r.right>b.left-8&&r.top<b.bottom+8&&r.bottom>b.top-8;
        });
      }
      root.toggleAttribute('data-chat-blocked',Boolean(priority||editing||collision));
    });
  }
  function viewport(){
    const v=window.visualViewport;
    for(const [name,value] of Object.entries({vh:v?.height||window.innerHeight,vw:v?.width||window.innerWidth,vtop:v?.offsetTop||0,vleft:v?.offsetLeft||0}))root.style.setProperty('--fc-'+name,value+'px');
  }
  function release(){
    if(!locked)return;locked=false;
    for(const [el,was] of background){el.inert=was;}background=[];
    document.body.style.cssText=lockState.body;document.documentElement.style.cssText=lockState.html;
    window.scrollTo(0,lockState.y);panel.removeAttribute('aria-modal');
  }
  function modal(){
    viewport();
    if(panel.hidden||!media.matches){release();return;}
    if(locked)return;
    locked=true;panel.setAttribute('aria-modal','true');
    lockState={body:document.body.style.cssText,html:document.documentElement.style.cssText,y:window.scrollY};
    document.body.style.position='fixed';document.body.style.top=-lockState.y+'px';document.body.style.width='100%';document.body.style.overflow='hidden';
    document.documentElement.style.overflow='hidden';
    for(let el=root;el&&el!==document.body;el=el.parentElement){
      for(const sibling of el.parentElement?.children||[]){
        if(sibling===el||/^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(sibling.tagName)||sibling.matches('#shopify-pc__banner,#shopify-pc__prefs,[data-cookie-banner],[data-consent-banner]')||sibling.querySelector('#shopify-pc__banner,#shopify-pc__prefs,[data-cookie-banner],[data-consent-banner]'))continue;
        background.push([sibling,!!sibling.inert]);sibling.inert=true;
      }
    }
  }
  function updateContext(){
    // Only this label changes locally. No DOM text or page fields enter an AI request.
    $('[data-chat-context]').textContent=(location.pathname===root.dataset.pagePath?root.dataset.pageTitle:document.title)||copy.unknown;
  }
  function open(){
    if(!panel.hidden||priorityDialog())return;
    lastFocus=document.activeElement;panel.hidden=false;toggle.setAttribute('aria-expanded','true');sync();modal();
    input.focus({preventScroll:true});resize();if(!hasOpened){toBottom();hasOpened=true;}
    if(!persistence)status.textContent=copy.storage;
  }
  function close(restoreFocus=true){
    panel.hidden=true;menu.open=false;toggle.setAttribute('aria-expanded','false');save();release();sync();
    if(!restoreFocus)return;
    const t=lastFocus?.isConnected&&lastFocus.matches('button:not(:disabled),a[href],input:not(:disabled),textarea:not(:disabled),select:not(:disabled),[tabindex]:not([tabindex="-1"])')?lastFocus:toggle;
    t.focus({preventScroll:true});if(document.activeElement!==t)toggle.focus({preventScroll:true});
  }
  function visitURL(value){
    const u=new URL(value);
    if(localePrefix)u.pathname=localePrefix+u.pathname;
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview&&/^\d+$/.test(preview))u.searchParams.set('preview_theme_id',preview);
    return u.href;
  }
  function append(role,message,links=[]){
    const entry=document.createElement('div');entry.className='fool-chat__message fool-chat__message--'+role;
    entry.setAttribute('aria-label',role==='user'?copy.me:copy.ai);
    if(role==='assistant'){
      const speaker=document.createElement('div');speaker.className='fool-chat__speaker';
      const icon=$('.fool-chat__compass').cloneNode(true);icon.removeAttribute('class');speaker.append(icon,document.createTextNode('MIRA'));entry.append(speaker);
    }
    const paragraph=document.createElement('p');paragraph.textContent=message;entry.append(paragraph);
    if(links.length&&window.FoolGuideRecommendations)entry.append(window.FoolGuideRecommendations.render({root,links,visitURL,save,onResize:changed,isCurrent:()=>entry.isConnected}));
    else for(const value of links.slice(0,2)){const a=document.createElement('a');a.href=visitURL(value.url);a.textContent=value.label;a.addEventListener('click',save);entry.append(a);}
    log.append(entry);
  }
  function requestMessages(content){
    let prior=history.length>10?[...history.slice(0,2),...history.slice(-8)]:history.slice(-10);
    prior=prior.map(({role,content})=>({role,content}));
    while(prior.length&&prior.reduce((n,m)=>n+m.content.length,content.length)>16000)prior.splice(prior.length>2?2:0,2);
    return [...prior,{role:'user',content}];
  }
  async function submit(page,attempt){
    if(busy)return;
    const submittedValue=attempt?.submittedValue??input.value,content=submittedValue.trim();
    if(!text(content,2000)){status.textContent=copy.empty;input.focus();return;}
    const messages=attempt?.messages||requestMessages(content),own=++generation;
    lastAttempt={submittedValue,messages,page:attempt?.page||page};
    controller=new AbortController();const active=controller;busy=true;retry.hidden=true;status.textContent=copy.working;following=nearBottom();sync();save();changed();
    const timer=setTimeout(()=>active.abort(),100000);
    const slow=setTimeout(()=>{if(own===generation)status.textContent=copy.slow;},12000);
    try{
      const response=await fetch(root.dataset.endpoint,{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},
        signal:active.signal,body:JSON.stringify({messages,...(lastAttempt.page?{page:lastAttempt.page}: {})})});
      if(!response.ok)throw Error(response.status===429?'limited':'failed');
      const raw=await response.text();if(raw.length>16000)throw Error('failed');
      const data=JSON.parse(raw);if(!valid(data))throw Error('failed');
      if(own!==generation||!root.isConnected)return;
      const links=data.links.slice(0,2);append('user',content);append('assistant',data.reply_message,links);
      history.push({role:'user',content},{role:'assistant',content:data.reply_message,links});
      if(history.length>40){
        history.splice(2,history.length-40);
        const before=scroll.scrollHeight;
        while(log.children.length>40)log.children[2].remove();
        if(!following)scroll.scrollTop-=before-scroll.scrollHeight;
      }
      if(input.value===submittedValue)input.value='';
      resize();status.replaceChildren();lastAttempt=null;
      if(data.needs_human){
        status.append(document.createTextNode(copy.human+' '));
        const a=document.createElement('a');a.href='mailto:thefool@worldofthefool.com';a.textContent=copy.email;status.append(a);
      }
      chips(data.quick_follow_up_chips);save();changed();
    }catch(e){if(own===generation){status.textContent=e.message==='limited'?copy.limited:copy.failed;retry.hidden=false;save();changed();}}
    finally{clearTimeout(timer);clearTimeout(slow);if(own===generation){busy=false;controller=null;sync();}}
  }
  function start(value,page){
    if(busy)return;
    if(input.value.trim()){status.textContent=copy.draft;input.focus();return;}
    input.value=value;resize();submit(page);
  }
  try{
    const raw=sessionStorage.getItem(key);
    if(raw){
      if(raw.length>120000)throw Error('invalid_state');
      const state=JSON.parse(raw),age=Date.now()-state.at;
      if(state.v!==2||!Number.isFinite(age)||age<0||age>ttl||!Array.isArray(state.history)||state.history.length>40||state.history.length%2||
        state.history.some((m,i)=>!m||m.role!==(i%2?'assistant':'user')||!text(m.content,2000)||(m.links!==undefined&&(!Array.isArray(m.links)||m.links.length>3||!m.links.every(safeLink))))||
        typeof state.draft!=='string'||state.draft.length>2000||!Array.isArray(state.chips)||state.chips.length>3||state.chips.some(s=>!text(s,100)))throw Error('invalid_state');
      history=state.history;input.value=state.draft;latestChips=state.chips;
      for(const m of history)append(m.role,m.content,m.links||[]);
    }
  }catch{try{sessionStorage.removeItem(key);}catch{storageFailure();}}
  toggle.addEventListener('click',open);
  $('[data-chat-close]').addEventListener('click',()=>close());
  $('[data-chat-minimize]').addEventListener('click',()=>close());
  root.addEventListener('keydown',e=>{
    if(e.key==='Escape'&&!panel.hidden){e.preventDefault();if(menu.open){menu.open=false;menu.querySelector('summary').focus();}else close();}
    if(e.key==='Tab'&&locked){
      const els=focusable(),first=els[0],last=els.at(-1);
      if((e.shiftKey&&document.activeElement===first)||(!e.shiftKey&&document.activeElement===last)){e.preventDefault();(e.shiftKey?last:first)?.focus();}
    }
  });
  document.addEventListener('focusin',e=>{if(locked&&!panel.contains(e.target)&&!priorityDialog())input.focus({preventScroll:true});scheduleOverlay();});
  document.addEventListener('focusout',scheduleOverlay);
  scroll.addEventListener('scroll',()=>{following=nearBottom();if(following)bottom.hidden=true;},{passive:true});
  bottom.addEventListener('click',toBottom);
  input.addEventListener('keydown',e=>{if(e.key==='Enter'&&!e.shiftKey&&!e.isComposing){e.preventDefault();submit();}});
  input.addEventListener('input',()=>{resize();sync();save();});
  send.addEventListener('click',()=>submit());
  retry.addEventListener('click',()=>{if(lastAttempt)submit(undefined,lastAttempt);});
  for(const b of root.querySelectorAll('[data-chat-starter]'))b.addEventListener('click',()=>start(copy.starters[b.dataset.chatStarter]));
  for(const a of root.querySelectorAll('[data-chat-route]')){a.href=visitURL('https://worldofthefool.com'+a.dataset.chatRoute);a.addEventListener('click',save);}
  $('[data-chat-explore]').addEventListener('click',()=>{
    let path=location.pathname;
    if(localePrefix&&(path===localePrefix||path.startsWith(localePrefix+'/')))path=path.slice(localePrefix.length)||'/';
    if(!/^(\/|\/pages\/[a-z0-9-]+|\/products\/[a-z0-9-]+|\/collections\/(all|shop)|\/policies\/[a-z0-9-]+)$/.test(path)||/\/(shadow-mirror|two-soul-resonance|journal)$/.test(path)){status.textContent=copy.private;return;}
    start(copy.guide,{path});
  });
  $('[data-chat-clear]').addEventListener('click',()=>{
    generation++;controller?.abort();controller=null;history=[];lastAttempt=null;busy=false;log.replaceChildren();input.value='';following=true;resize();status.textContent=copy.cleared;menu.open=false;retry.hidden=true;chips([]);
    try{sessionStorage.removeItem(key);}catch{storageFailure();}input.focus();
  });
  document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false;});
  media.addEventListener('change',modal);
  window.visualViewport?.addEventListener('resize',viewport);
  window.visualViewport?.addEventListener('scroll',viewport);
  window.addEventListener('resize',()=>{viewport();scheduleOverlay();});
  window.addEventListener('scroll',scheduleOverlay,{passive:true});
  document.addEventListener('toggle',scheduleOverlay,true);
  window.addEventListener('popstate',updateContext);
  window.addEventListener('pagehide',()=>{save();generation++;controller?.abort();controller=null;busy=false;status.replaceChildren();release();sync();});
  window.addEventListener('pageshow',event=>{updateContext();if(event.persisted){busy=false;controller=null;sync();modal();resize();}});
  new MutationObserver(scheduleOverlay).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-modal','hidden','style','class']});
  document.addEventListener('click',e=>{if(e.target.closest('[data-mobile-chat-launcher]')){e.preventDefault();e.stopImmediatePropagation();open();}},true);
  window.FoolShopChat={open};
  window.dispatchEvent(new Event('fool:shop-chat-ready'));
  updateContext();chips(latestChips);resize();scheduleOverlay();
})();

